import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Survey } from 'src/app/models/survey/survey';
import { SurveyService } from '../../../services/survey/survey.service';
import { QuestionTypeService } from '../../../services/survey/question-type.service';
import { QuestionType } from 'src/app/models/survey/questionType';
import { QuestionService } from 'src/app/services/survey/question.service';
import { Question } from 'src/app/models/survey/question';
import { OptionsService } from 'src/app/services/survey/options.service';
import { Option } from 'src/app/models/survey/options';
import { Observable } from 'rxjs';
import { Axis } from 'src/app/models/survey/axis';
import { AxisService } from 'src/app/services/survey/axis.service';
import { Message } from 'src/app/models/message';

@Component({
  selector: 'app-surveys-page',
  templateUrl: './surveys-page.component.html',
  styleUrls: ['./surveys-page.component.scss']
})
export class SurveysPageComponent implements OnInit {

  formEdit: FormGroup;
  formArrayQst: FormArray;
  surveys: Survey;
  edit: boolean = false;
  addQ: boolean = false;
  lastQuestion: number = 0;
  saved: boolean = true;
  msg: Message = null;

  oOption: Option = {
    id: 0,
    idquestion: 0,
    label: '',
    isMatrix: null
  }

  oQuestion: Question = {
    id: 0,
    idquestiontype: 0,
    idsection: 0,
    label: '',
    summary: '',
    detail: '',
    order: 0,
    options: []
  }

  survey: Survey = {
    id: 0,
    idcreator: 0,
    idstatus: 3,
    name: '',
    title: 'Encuesta de prueba',
    startdate: null,
    lastaccess: null,
    enddate: null,
    logo: '',
    isOpened: null,
    isComplete: null,
    sections: []
  }

  qtype: QuestionType[];
  qts: Question[];
  opts: Option[];

  menuOpp: boolean = false;

  constructor(
    private svService: SurveyService,
    private qtService: QuestionTypeService,
    private qService: QuestionService,
    private optService: OptionsService,
    private axService: AxisService,
    private fb: FormBuilder,
    private fb2: FormBuilder,
    private actRoute: ActivatedRoute) {
    //this.getQuestions();
  }

  ngOnInit() {
    this.createForm();
    this.getSurvey();
    this.getQType();
  }

  createForm() {
    this.formEdit = this.fb.group({
      id: [null],
      idcreator: [null],
      idstatus: [''],
      name: [''],
      title: [''],
      isActive: [],
      questions: this.fb.array([
        this.fb.group({
          id: [null],
          idquestiontype: [null],
          idsurvey: [null],
          label: [''],
          summary: [''],
          detail: [''],
          order: [''],
          options: this.fb.array([
            this.fb.group({
              id: [null],
              idquestion: [null],
              label: [null],
              isMatrix: [null],
            })
          ])
        })
      ])
    });

  }

  getSurvey() {
    const params = this.actRoute.snapshot.params;
    if (params['id']) {
      this.svService.getOne(params['id'])
        .subscribe(
          res => {
            this.survey = res['data'];
            this.edit = true;
            this.getQ4Survey(params['id']);
          },
          err => console.error(err)
        );
    } else {
      this.edit = false;
    }
  }

  getQType() {
    this.qtService.getAll()
      .subscribe(
        res => {
          this.qtype = res['data'];
        },
        err => console.error(err)
      );

  }

  getQ4Survey(id: string) {
    this.qService.get4Section(id.toString())
      .subscribe(
        res => {
          this.qts = res['data'];
          this.survey.sections = this.qts;
          this.loadData();
          this.getLastQuestion(this.qts);
          this.getOpts4Q(this.qts);
        },
        err => console.error(err)
      );
  }

  getLastQuestion(qts: Question[]) {
    qts.forEach(o => {
      if (this.lastQuestion < o.order) {
        this.lastQuestion = o.order;
      }
    });
  }

  getOpts4Q(question: Question[]) {
    console.log("Model pre-options: ", this.formEdit.value)
    this.opts = [];
    question.forEach((q, i) => {
      this.optService.get4question(q.id + '')
        .subscribe(
          res => {
            const temp: Option[] = res['data'];
            if (temp.length > 0) {
              //this.survey.sections[i].options = res['data'];
              //this.addOptionsToModel(i, this.survey.sections[i].options);
              this.formEdit.reset(this.survey);
            }

          },
          err => console.error(err)
        );
    });
    //this.loadDataOpts();
  }

  save() {
    if (this.formEdit.invalid) {
      return Object.values(this.formEdit.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.updateSurvey(this.formEdit.value.id, this.formEdit.value);
    }
  }

  saveQ(q: string) {
    if (this.formEdit.invalid) {
      return Object.values(this.formEdit.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      //this.formEdit.controls.value
      this.formEdit.controls['questions'].value.forEach(e => {
        if (e.id == q) {
          this.updateQuestion(e.id, e);
        }
      });
    }
  }

  saveOp(op: string) {
    if (this.formEdit.invalid) {
      return Object.values(this.formEdit.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      //this.formEdit.controls.value
      this.formEdit.controls['questions'].value.forEach((q: Question) => {
        q.options.forEach(o => {
          if (o.id == +op) {
            this.updateOption(o.id + '', q);
          }
        });
      });
    }
  }

  get questions() {
    return this.formEdit.get('questions') as FormArray;
  }

  options(i: number) {
    //console.log("Options: ",(<FormArray>(<FormArray>this.formEdit.get('questions')).at(i).get('options')).controls)
    return (<FormArray>this.formEdit.get('questions')).at(i).get('options') as FormArray;
  }

  addQuestionToModel() {
    this.questions.push(
      this.fb.group({
        id: [null],
        idquestiontype: [null],
        idsurvey: [null],
        label: [''],
        summary: [''],
        detail: [''],
        order: [''],
        options: this.fb.array([
          this.fb.group({
            id: [null],
            idquestion: [null],
            label: [''],
            order: [0],
            isMatrix: [null],
          })
        ])
      })
    );
  }

  addOptionsToModel(i: number, opts: Option[]) {
    opts.forEach(o => {
      this.options(i).push(
        this.fb.group({
          id: [null],
          idquestion: [null],
          label: [''],
          order: [''],
          isMatrix: ['']
        })
      );

    });
  }

  createSurvey(o: Survey) {
    delete o.id;
    let id: string;
    this.svService.create(o)
      .subscribe(
        res => {
          console.log("Surv create: ", res)
        },
        err => console.error(err))
  }

  createQuestionAndOptions(o: Question, idqt: number) {
    delete o.id;
    this.qService.create(o)
      .subscribe(
        res => {
          console.log("Question created: ", res.id)
          this.addNewOptions(res.id, idqt);
        },
        err => console.error(err));

  }

  createOption(o: Option) {
    delete o.id;
    this.optService.create(o)
      .subscribe(
        res => {
          console.log("Option created: ", res.id)
          if (o.isMatrix) {
            this.addNewAxis(+res.id);
          }
        },
        err => console.error(err));
  }

  createAxis(o: Axis) {
    delete o.id;
    this.axService.create(o)
      .subscribe(
        res => {
          console.log("Axis created: ", res.id)
        },
        err => console.error(err));
  }

  updateSurvey(id: string, o: Survey) {
    delete o.id;
    this.svService.update(id, o)
      .subscribe(
        res => {
          console.log("Surv update: ", res)
        },
        err => console.error(err))
  }

  updateQuestion(id: string, o: Question) {
    delete o.id;
    this.qService.update(id, o)
      .subscribe(
        res => {
          console.log("Question updated: ", res)
        },
        err => console.error(err))
  }

  updateOption(id: string, o: Option) {
    delete o.id;
    this.optService.update(id, o)
      .subscribe(
        res => {
          console.log("Option updated: ", res)
        },
        err => console.error(err))
  }

  addNewQuestion(idq: number) {
    let q: Question = {
      idsection: this.survey.id,
      idquestiontype: idq,
      label: 'Texto de la pregunta',
      order: this.lastQuestion + 1
    };

    //  Si existe una encuesta
    if (this.survey) {
      this.createQuestionAndOptions(q, idq);
    }

  }

  addNewOptions(idq: number, idqt: number) {
    switch (idqt) {
      case 1: {
        console.log("Politomica")
        this.addPolitomicQuestion(idq);
        break;
      }
      case 2: {

        break;
      }
      case 3: {
        console.log("Múltiple")
        this.addPolitomicQuestion(idq);
        break;
      }
      case 4: {
        console.log("Mixta")
        this.addPolitomicQuestion(idq);
        break;
      }
      case 5: {
        console.log("Escala nominal")
        this.addPolitomicQuestion(idq);
        break;
      }
      case 6: {
        console.log("Escala Likert")
        this.addLikertQuestion(idq);
        break;
      }
      case 9: {
        console.log("Texto simple")
        this.addTextQuestion(idq);
        break;
      }
      case 10: {
        console.log("Comentario")
        this.addTextQuestion(idq);
        break;
      }
      case 11: {
        console.log("Matriz")
        this.addMatrixQuestion(idq);
        break;
      }
      case 12: {
        console.log("Nota")
        break;
      }

      default:
        break;
    }
    this.getSurvey();
  }

  addOneOption(idq: number) {
    let op: Option = {
      idquestion: idq, label: 'Nueva opción'
    };
    this.createOption(op);
    this.getSurvey();
  }

  addPolitomicQuestion(idq: number) {
    let op: Option[] = [
      { idquestion: idq, label: 'Opción 1' },
      { idquestion: idq, label: 'Opción 2' },
      { idquestion: idq, label: 'Opción 3' },
    ];

    op.forEach(o => {
      this.createOption(o);
    });
  }

  addLikertQuestion(idq: number) {
    let op: Option[] = [
      { idquestion: idq, label: 'No es importante' },
      { idquestion: idq, label: 'Poco importante' },
      { idquestion: idq, label: 'Neutral' },
      { idquestion: idq, label: 'Importante' },
      { idquestion: idq, label: 'Muy importante' },
    ];

    op.forEach(o => {
      this.createOption(o);
    });
  }

  addMatrixQuestion(idq: number) {
    let op: Option[] = [
      { idquestion: idq, label: 'Fila 1', isMatrix: true }
    ];

    op.forEach(o => {
      this.createOption(o);
    });
  }

  addNewAxis(idx: number) {
    let ax: Axis[] = [
      { idoptions: idx, type: 1, label: 'Fila 1' },
      { idoptions: idx, type: 1, label: 'Fila 2' },
      { idoptions: idx, type: 1, label: 'Fila 3' },
      { idoptions: idx, type: 2, label: 'Muy insatisfecho' },
      { idoptions: idx, type: 2, label: 'Insatisfecho' },
      { idoptions: idx, type: 2, label: 'Neutral' },
      { idoptions: idx, type: 2, label: 'Satisfecho' },
      { idoptions: idx, type: 2, label: 'Muy satisfecho' },
      { idoptions: idx, type: 3, label: 'Dimensión 1' },
    ];

    ax.forEach(o => {
      this.createAxis(o);
    });
  }

  addTextQuestion(idq: number) {
    let op: Option[] = [
      { idquestion: idq, label: 'Texto' }
    ];

    op.forEach(o => {
      this.createOption(o);
    });
  }

  guardar() {
    this.saved = true;
    /*     this.qService.update(idsurvey, o)
          .subscribe(
            res => {
              console.log("Question updated: ", res)
            },
            err => console.error(err)) */
    /*     display(){
          this.foodservice.getFood()
            .subscribe(data => {
              setTimeout(()=>{ this.display = "" }, 4000)
            }    
        
        } */
  }
  loadData() {
    for (let i = 0; i < (this.qts.length - 1); i++) {
      this.addQuestionToModel();
    }
    this.formEdit.reset(this.survey);
  }

  async loadDataOpts() {
    //console.log("Options: ", this.survey.sections[0].options);
    await this.survey.sections.forEach((q) => {
      console.log(this.options)


      /* q.options.forEach(o => {
        this.addOptionsToModel();
      }); */
    });
    this.formEdit.reset(this.survey);
  }

  loadDataQst() {
    //this.formArrayQst.reset(this.qts);
    //this.formArrayQst.clear;
    const array = new FormArray([]);
    this.qts.forEach((o, i) => {
      array.push(this.fb.control({
        id: o.id,
        idquestiontype: o.idquestiontype,
        idsection: o.idsection,
        label: o.label,
        summary: o.summary,
        detail: o.detail,
        order: o.order,
        isActive: o.isActive,
        isRequired: o.isRequired,
        img: o.img,
        createdAt: o.createdAt,
        updatedAt: o.updatedAt
      }));
      this.formArrayQst = array;

    });

    console.log("formArrayQst: ", this.formArrayQst.controls);
  }

  capitalize(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

}

